<template>
    <!-- <vue-plyr>
        <audio controls playsinline :src="url"> </audio>
    </vue-plyr>   -->
    <div class="d-flex">
        <audio controls controlsList="nodownload" style="width: 100%;">
            <source :src="url" />
        </audio>
    </div>
</template>

<script>

import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
import Vue from 'vue'
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true },
    controls: ['play-large', 'play', 'current-time', 'progress',  'fullscreen'],
  },
  emit: ['ended']
})

export default {
    props: {
        url: {required: true},
    },
    data(){
        return {

        }
    }
}
</script>
<style lang="scss">
.v-application .plyr *{
    font-family: "open sans", sans-serif, arial!important;
}
.plyr--full-ui input[type=range] {
    color: #332575;
}

.plyr__control--overlaid {
  background: rgba(#332575, .8);
}

.plyr--video .plyr__control.plyr__tab-focus,
.plyr--video .plyr__control:hover,
.plyr--video .plyr__control[aria-expanded=true] {
  background: #332575;
}

.plyr__control.plyr__tab-focus {
  box-shadow: 0 0 0 5px rgba(#332575, .5);
}

.plyr__menu__container .plyr__control[role=menuitemradio][aria-checked=true]::before, .plyr__controls__item.plyr__control:hover{
  background: #332575;
}
</style>